<div class="container-fluid pb-3 mt-4 px-0 game-details">
	<button type="button" class="close" data-dismiss="dialog" (click)="close()">
		<span aria-hidden="true">&times;</span>
		<span class="sr-only" cvLocalizedText langSection="Common" langKey="Close">Close</span>
	</button>

	<!-- Header Game -->
	<div class="mt-4">
		<div class="d-flex flex-row justify-content-start">
			<div class="col-2 p-0 {{game.iconClass}}" style="min-width: 40px; width: 40px; height: 40px; background-size: 40px; background-repeat: no-repeat; background-position: center;"></div>
			<div class="d-flex flex-column pl-2 col-10">
				<div class="font-size-14 text-truncate text-left color-whaleTail">{{gs.selectedGame[0].underlyingRule.RuleName}}</div>
				<div class="font-size-12 text-left color-valyrianSteel">{{game.gameTypeName}}</div>
			</div>
		</div>
	</div>
	<!-- Game Information -->
	<div class="d-flex justify-content-between flex-column">
		<div class="color-whaleTail pt-2 pb-2 font-size-14" [ngSwitch]="game.underlyingRule.GameType">
			<span id="desc_MM" *ngSwitchCase="1" cvLocalizedText langSection="Games_History" langKey="DescMM">Commission style game; players rewarded per KPI unit achieved. Should only be used for count-type metrics.</span>
			<span id="desc_TD" *ngSwitchCase="2" cvLocalizedText langSection="Games_History" langKey="DescTD">Players rewarded according to how they rank against other players.</span>
			<span id="desc_BE" *ngSwitchCase="3" cvLocalizedText langSection="Games_History" langKey="DescBE">Players rewarded according to where they hit on the target (bullseye and rings).</span>
			<span id="desc_C3" *ngSwitchCase="6" cvLocalizedText langSection="Games_History" langKey="DescC3">Earn reward by connecting 3 metrics in a row. Horizontal, vertical, or diagonal connections count.</span>
      <span id="desc_TT" *ngSwitchCase="8" cvLocalizedText langSection="Games_History" langKey="DescTT">"Teams" win rewards according to where they rank in comparinson with other teams.</span>
      <span id="desc_RR" *ngSwitchCase="9" cvLocalizedText langSection="Games_History" langKey="DescRR">Prize(s) will be given out to a random qualified Participant.</span>
		</div>
	</div>
	<!-- Game Information -->
	<div class="d-flex justify-content-between">
		<div class="pt-3 pb-3 w-100 d-flex border-top border-bottom flex-column">
			<div class="d-flex flex-row color-valyrianSteel font-size-14">
				<div class="w-25" *ngIf="gameData.underlyingRule.GameType != 6 && gameData.underlyingRule.GameType != 7">
                    <span class="pr-1" cvLocalizedText langSection="Objectives" langKey="Metric">Metric:</span>
				</div>
				<div class="w-75"><span class="r-1" cvLocalizedText langSection="Rules_Engine" langKey="Qualifier">Qualifier</span><span>:</span></div>
			</div>
			<div class="d-flex flex-row">
				<div class="w-25 text-break" *ngIf="gameData.underlyingRule.GameType != 6 && gameData.underlyingRule.GameType != 7"><span class="color-whaleTail font-size-16 lato-bold">{{game.SelectedMetrics[0]?.abbrev}}</span></div>
				<div class="w-25 text-break"><span class="color-whaleTail font-size-16 lato-bold">{{(game.Qualifier != null ? game.Qualifier.abbrev : getLocalizedText("None", "None"))}}</span></div>
				<div *ngIf="game.QualifierLevels != undefined" class="border-left pl-1" [ngSwitch]="game.QualifierLevels.comparerType">
                    <span *ngSwitchCase="1" class="color-whaleTail font-size-12">{{(game.Qualifier != null ? (getLocalizedText("Greater_Than", "Greather Than") + " " +  getFormattedMetric(game.QualifierLevels.leftNumber, game.Qualifier.conversionType)) : "")}}</span>
                    <span *ngSwitchCase="2" class="color-whaleTail font-size-12">{{(game.Qualifier != null ? (getLocalizedText("Less_Than", "Less Than") + " " + getFormattedMetric(game.QualifierLevels.leftNumber, game.Qualifier.conversionType)) : "")}}</span>
                    <span *ngSwitchCase="3" class="color-whaleTail font-size-12">{{(game.Qualifier != null ? (getLocalizedText("Between", "Between") + " " + getFormattedMetric(game.QualifierLevels.leftNumber, game.Qualifier.conversionType) + " " + getLocalizedText("And", "And") + " " + getFormattedMetric(game.QualifierLevels.rightNumber, game.Qualifier.conversionType)) : "")}}</span>
                </div>
			</div>
            
            <!-- Second line -->
            <div class="d-flex flex-row color-valyrianSteel font-size-14" *ngIf="gameData.underlyingRule.GameType == 10">
                <div class="w-50">
                    <span class="pr-1" cvLocalizedText langSection="Games" langKey="Players">Players</span><!--Translate-->
				</div>
            </div>
            <div class="d-flex flex-row" *ngIf="gameData.underlyingRule.GameType == 10">
				<div class="w-50 text-break" *ngIf="gameData.underlyingRule.GameType == 10">
                    <span class="color-whaleTail font-size-16 lato-bold">{{getBracketTournamentPlayers(gameData.BracketTournamentDetails.NumberOfRounds)}}</span>
                </div>
			</div>

            <!-- Third line -->
            <div class="d-flex flex-row color-valyrianSteel font-size-14" *ngIf="gameData.underlyingRule.GameType == 10">
				<div class="w-50">
                    <span class="pr-1" cvLocalizedText langSection="Games" langKey="Total_Matches">Total matches</span>
				</div>
				<div class="w-50"><span class="r-1" cvLocalizedText langSection="Games" langKey="Total_Rounds">Total Rounds</span></div>
			</div>
			<div class="d-flex flex-row" *ngIf="gameData.underlyingRule.GameType == 10">
				<div class="w-50 text-break"><span class="color-whaleTail font-size-16 lato-bold">{{getBracketTournamentMatches(gameData.BracketTournamentDetails.NumberOfRounds)}}</span></div>
				<div class="w-50 text-break"><span class="color-whaleTail font-size-16 lato-bold">{{gameData.BracketTournamentDetails.NumberOfRounds}}</span></div>
			</div>
		</div>
	</div>

	<!-- Connect3 - Display Metrics -->
	<div class="row p-2"  *ngIf="(gameData.underlyingRule.GameType == 6 || gameData.underlyingRule.GameType == 7)">
        <div class="col-4" *ngFor="let metricPosition of gameData.Connect3Positions">
            <div class="card p-2 mx-n2 my-2 text-center font-size-18" 
                [ngClass]="getConnect3Class(metricPosition, gameData.underlyingRule.GameType)" style="height:100px">
                <div *ngIf="getCheck(metricPosition.position)" class="d-flex flex-row-reverse ">
                    <div class="icon-16 checkMarkConnect3"></div>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <div class="metric-container">
                        <div *ngIf="metricPosition.metric == null"><svg class="icon-16 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg></div>
                        <div class="font-size-14">{{(metricPosition.metric ==  null ? getLocalizedText("Metric_Goal", "Metric Goal") : (getLocalizedText(metricPosition.metric.abbrev.replace(" ", "_"), metricPosition.metric.abbrev)))}}</div>
                        <div *ngIf="metricPosition.targetObj != undefined && metricPosition.targetObj.Target != null" class="font-size-14">
                            {{(metricPosition.metric.direction === "0") ? "<" : ">"}}
                            {{getFormattedMetric(metricPosition.targetObj.Target, metricPosition.metric.conversionType)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

	<!-- Rewards Section -->
	<div class="container-fluid p-0">
		<div class="row">
			<div class="col-sm-12 pt-3">
				<span class="color-valyrianSteel font-size-14" cvLocalizedText langSection="Games" langKey="Reward_Breakdown">Reward Breakdown</span>
			</div>
		</div>

        <!--Multiplier Madness Rewards -->
        <div class="container p-0 mt-2" *ngIf="gameData.underlyingRule.GameType == 1">
            <div class="row">
                <div class="col-sm-12 pb-2 lato-bold font-size-12 colorMultiplierMadness">
                    {{gameData.MultiplierMadnessRewards.coins}} Coins per {{gameData.SelectedMetrics[0].abbrev}}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 pb-2 lato-bold font-size-12 colorMultiplierMadness">
                    {{gameData.MultiplierMadnessRewards.xp}} XP per {{gameData.SelectedMetrics[0].abbrev}}
                </div>
            </div>
        </div>

        <!--Top Dog Rewards or Top Team Rewards-->
        <div class="pl-2 pr-2" *ngIf="gameData.underlyingRule.GameType == 2 || gameData.underlyingRule.GameType == 8">
            <div class="d-flex flex-column w-100">
                <div *ngFor="let TopDogReward of gameData.TopDogRewards; let index = index" class="pt-1">
                    <div>
                        <div class="d-flex pt-2">
                            <div class="d-flex">
							    <div *ngIf="index == 0" class="topDogRankIcon topDogRank1" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 1" class="topDogRankIcon topDogRank2" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 2" class="topDogRankIcon topDogRank3" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 3" class="topDogRankIcon topDogRank4" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                                <div *ngIf="index == 4" class="topDogRankIcon topDogRank5" style="width: 20px; height: 37px; display: block; background-size: 18px; background-position: center;"></div>
                            </div>
                            <div class="d-flex justify-content-between w-100">
                                <div class="d-flex align-items-center justify-content-between ml-2 px-3">
                                    {{(gameData.TopDogRewards[index].Coins != null ? gameData.TopDogRewards[index].Coins.rewardValue : "---")}}&nbsp;
                                    <span cvLocalizedText langSection="Games" langKey="Coins"></span>
                                </div>
							
                                <div class="d-flex align-items-center justify-content-between border-left px-3">
                                    {{(gameData.TopDogRewards[index].XP != null ? gameData.TopDogRewards[index].XP.rewardValue : "---")}}&nbsp;
                                    <span cvLocalizedText langSection="Games" langKey="XP"></span>
                                </div>

                                <div class="d-flex align-items-center justify-content-between border-left px-3">
								    <div *ngIf="getBadge(gameData, index) != null" class="d-flex align-items-center">
                                        <img [src]="getBadge(gameData, index)" />
                                    </div>
								    <div *ngIf="getBadge(gameData, index) == null">---</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		
        <!--Bullseye Rewards -->
        <div class="px-0" *ngIf="gameData.underlyingRule.GameType == 3">
            <div class="d-flex flex-column w-100">
                <div *ngFor="let bullseyeReward of gameData.BullseyeRewards; let index = index" class="pt-2 pl-1">
                    <div>
                        <div class="d-flex pt-2">
                            <div class="d-flex">
							    <div *ngIf="index == 0" class="bullseyeTargetIcon tier1" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 1" class="bullseyeTargetIcon tier2" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 2" class="bullseyeTargetIcon tier3" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 3" class="bullseyeTargetIcon tier4" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                                <div *ngIf="index == 4" class="bullseyeTargetIcon tier5" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center;"></div>
                            </div>
                            <div class="d-flex justify-content-between w-100">
                                <div class="d-flex align-items-center justify-content-between px-3">
                                    {{(gameData.BullseyeRewards[index].Coins != null ? gameData.BullseyeRewards[index].Coins.rewardValue : "---")}}&nbsp;{{getLocalizedText("Coins", "Coins")}}
                                </div>
							
                                <div class="d-flex align-items-center justify-content-between border-left px-3">
                                    {{(gameData.BullseyeRewards[index].XP != null ? gameData.BullseyeRewards[index].XP.rewardValue : "---")}}&nbsp;{{getLocalizedText("XP", "XP")}}
                                </div>

                                <div class="d-flex align-items-center justify-content-between border-left px-3">
								    <div *ngIf="getBadge(gameData, index) != null" class="d-flex align-items-center">
                                        <img [src]="getBadge(gameData, index)" />
                                    </div>
								    <div *ngIf="getBadge(gameData, index) == null">---</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Connect3 -->
        <div class="pl-1 pr-1" *ngIf="gameData.underlyingRule.GameType == 6">
            <div class="container col-12">
                <div class="row">
                    <div class="d-flex flex-column w-100" style="border-top: 1px solid #D2D6DB;">
                        <div class="d-flex justify-content-between pt-2">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.ThreeInRow.coins != null ? gameData.Connect3Rewards.ThreeInRow.coins : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.ThreeInRow.xp != null ? gameData.Connect3Rewards.ThreeInRow.xp : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0 hide">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/currency.svg#currency"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.ThreeInRow.currency != null ? gameData.Connect3Rewards.ThreeInRow.currency.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="getBadgeImage(gameData, 0) != null" class="d-flex align-items-center">
                                            <img [src]="getBadgeImage(gameData, 0)" class="img-fluid" />
                                        </div>
                                        <div *ngIf="getBadgeImage(gameData, 0) == null">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Blackout Game -->
        <div class="pl-1 pr-1" *ngIf="gameData.underlyingRule.GameType == 7">
            <div class="container col-12">
                <div class="row">
                    <div class="d-flex flex-column w-100" style="border-top: 1px solid #D2D6DB;">
                        <div class="d-flex justify-content-between pt-2">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.Blackout.coins != null ? gameData.Connect3Rewards.Blackout.coins : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.Blackout.xp != null ? gameData.Connect3Rewards.Blackout.xp : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0 hide">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/currency.svg#currency"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.Connect3Rewards.Blackout.currency != null ? gameData.Connect3Rewards.Blackout.currency : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="getBadgeImage(gameData, 0) != null" class="d-flex align-items-center">
                                            <img [src]="getBadgeImage(gameData, 0)" class="img-fluid" />
                                        </div>
                                        <div *ngIf="getBadgeImage(gameData, 0) == null">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Milestone Rewards -->
        <div *ngIf="gameData.underlyingRule.GameType == 5">
            <div class="d-flex flex-column w-100">
                <div *ngFor="let milestoneReward of gameData.MilestoneRewards; let index = index" class="pt-2 pl-1"> <!-- | orderBy:milestoneReward:reverse-->
                    <div>
                        <div class="d-flex pt-2">
                            <div class="d-flex">
                                <div class="tier1" [ngStyle]="getCheckmark(index)" style="width: 42px; height: 42px; display: block; background-size: 40px; background-repeat: no-repeat; background-position: center;"></div>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex align-items-center justify-content-between ml-3 font-size-14 lato-bold  colorMilestone">Milestone {{index+1}}&nbsp;</div>
                                    <div [ngSwitch]="gameData.MilestoneRewards[index].ComparisonType" class="d-flex pl-2 align-items-center justify-content-between ml-3 font-size-14 lato-bold border-left">
                                        <span *ngSwitchCase="1" class="color-whaleTail font-size-12">{{( gameData.MilestoneRewards[index].Target != null ?  getLocalizedText("Greater_Than", "Greather Than") + " " + getFormattedMetric(gameData.MilestoneRewards[index].Target.Val1, gameData.SelectedMetrics[0].conversionType) : "")}}</span>
                                        <span *ngSwitchCase="2" class="color-whaleTail font-size-12">{{( gameData.MilestoneRewards[index].Target != null ?  getLocalizedText("Less_Than", "Less Than") + " " + getFormattedMetric(gameData.MilestoneRewards[index].Target.Val1, gameData.SelectedMetrics[0].conversionType) : "")}}</span>
                                        <span *ngSwitchCase="3" class="color-whaleTail font-size-12">{{( gameData.MilestoneRewards[index].Target != null ?  getLocalizedText("Between", "Between") + " " + getFormattedMetric(gameData.MilestoneRewards[index].Target.Val1, gameData.SelectedMetrics[0].conversionType) + " " +  getLocalizedText("And", "And") + " " + getFormattedMetric(gameData.MilestoneRewards[index].Target.Val2, gameData.SelectedMetrics[0].conversionType) : "")}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between pt-2">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.MilestoneRewards[index].Coins != null ? gameData.MilestoneRewards[index].Coins.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.MilestoneRewards[index].XP != null ? gameData.MilestoneRewards[index].XP.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0 hide">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/currency.svg#currency"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(gameData.MilestoneRewards[index].Currency != null ? gameData.MilestoneRewards[index].Currency.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="getBadge(gameData, index) != null" class="d-flex align-items-center">
                                            <img [src]="getBadge(gameData, index)" class="img-fluid" />
                                        </div>
                                        <div *ngIf="getBadge(gameData, index) == null">---</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Raffle Rewards -->
        <div *ngIf="gameData.underlyingRule.GameType == 9">
            <div class="d-flex flex-column w-100">
                <div class="raffle-rewards-details" *ngFor="let RaffleRewards of gameData.RaffleRewards; index as i">
                    <p class="w-25 text-break raffle-prize-details">{{getRank(i)}} Prize</p>
                    <p *ngIf="RaffleRewards.Coins.rewardValue > 0" class="w-25 text-break raffle-prize-coins">{{RaffleRewards.Coins.rewardValue}} Coins</p>
                    <p *ngIf="RaffleRewards.XP.rewardValue > 0" class="w-25 text-break raffle-prize-xp">{{RaffleRewards.XP.rewardValue}} XP</p>
                    <p *ngIf="RaffleRewards.Custom.rewardValue > 0 && raffleRewardsProducts[RaffleRewards.Custom.rewardValue]?.Title?.length > 0" class="text-break raffle-prize-custom">{{raffleRewardsProducts[RaffleRewards.Custom.rewardValue]?.Title}}</p>
                </div>
            </div>
        </div>

        <!-- Brackets Tournament -->
        <div *ngIf="gameData.underlyingRule.GameType == 10">
            <div class="container col-12">
                <div class="row" *ngFor="let BracketsTournamentRewards of gameData.BracketsTournamentRewards.slice().reverse(); index as i">
                    <div class="d-flex flex-column w-100">
                        <div class="pt-2" [ngSwitch]="gameData.BracketsTournamentRewards.length - i">
                            <span *ngSwitchCase="1" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_1_Final">Final</span>
                            <span *ngSwitchCase="2" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_2_Semi_Finals">Semi Finals</span>
                            <span *ngSwitchCase="3" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_3_Quarter">Quarters</span>
                            <span *ngSwitchCase="4" class="colorBracketTournament font-size-14" cvLocalizedText langSection="Games" langKey="Round_4_Octaves">Octaves</span>
                        </div>

                        <div class="d-flex justify-content-between pt-1 ml-n2" *ngIf="BracketsTournamentRewards.isSystemReward">
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(BracketsTournamentRewards.Coins.rewardValue > 0 ? BracketsTournamentRewards.Coins.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">{{(BracketsTournamentRewards.XP.rewardValue > 0 ? BracketsTournamentRewards.XP.rewardValue : "---")}}</div>
                                </div>
                            </div>
                            <div class="col-3 pl-0">
                                <div class="row">
                                    <div class="col-sm-6 text-right m-0 p-0">
                                        <svg class="icon-16 fill-valyrianSteel">
                                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                                        </svg>
                                    </div>
                                    <div class="col-sm-6 m-0 p-0 pl-1 text-left lato-bold color-whaleTail font-size-14">
                                        <div *ngIf="getBadgeImage(gameData, gameData.BracketsTournamentRewards.length - i - 1) as badgeImage; else noBadge" class="d-flex align-items-center">
                                            <img [src]="badgeImage" class="img-fluid" />
                                        </div>
                                        <ng-template #noBadge>
                                            <div>---</div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between pt-1" *ngIf="!BracketsTournamentRewards.isSystemReward">
                            <div class="col-12 pl-0">
                                <p *ngIf="BracketsTournamentRewards.Custom.rewardValue > 0 && raffleRewardsProducts[BracketsTournamentRewards.Custom.rewardValue]?.Title?.length > 0" class="text-break brackets-prize-custom mb-0">{{raffleRewardsProducts[BracketsTournamentRewards.Custom.rewardValue]?.Title}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
